import { throwError as observableThrowError, Observable } from "rxjs";

import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";

import { Router } from "@angular/router";
import { HttpClient } from "../../../shared/services/http/http-client.service";

@Injectable({ providedIn: "root" })
export class ConfigService {
  currentSettup: any;
  constructor(
    private router: Router,
    private _http: HttpClient
  ) {}

  findLastVersion() {
    return this._http.get("api/config/findLastVersion").pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  findByVersion(version: number) {
    return this._http.get("api/config/findByVersion/" + version).pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  listVersions() {
    return this._http.get("api/config/listVersions").pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  update(newData: any) {
    return this._http.patch("api/config", newData).pipe(
      map(async (res) => {
        await this.getCurrentSetup(true);
        return res;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  getCurrentSetup(forceFetch = false) {
    return new Promise((resolve, reject) => {
      if (!forceFetch && this.currentSettup) {
        resolve(this.currentSettup);
      } else {
        return this.findLastVersion()
          .toPromise()
          .then((currentSettings) => {
            return this.listVersions()
              .toPromise()
              .then((versions) => {
                this.currentSettup = { currentSettings, versions };
                resolve(this.currentSettup);
              });
          });
      }
    });
  }

  getDriverNotesCcEmail() {
    return this._http.get("api/config/driverNotesCcEmail").pipe(
      map((res: any) => {
        return res.ccEmail;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  getDriverNotesFromEmail() {
    return this._http.get("api/config/driverNotesFromEmail").pipe(
      map((res: any) => {
        return { email: res.email || "", name: res.name || "" };
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  getCurrentUserEmailSignature() {
    return this._http.get("api/config/currentUserEmailSignature").pipe(
      map((res: any) => {
        return res.signature || "";
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }

  updateCurrentUserEmailSignature(signature: string) {
    return this._http
      .post("api/config/currentUserEmailSignature", { signature: signature ?? "" })
      .pipe(
        map((res: any) => {
          return res.signature || "";
        }),
        catchError((error: any) => observableThrowError(error.message || "Server error"))
      );
  }

  getOmahaDispatchEmail() {
    return this._http.get("api/config/omahaDispatchEmail").pipe(
      map((res: any) => {
        return res.email;
      }),
      catchError((error: any) => observableThrowError(error.message || "Server error"))
    );
  }
}
